let wasm;
export function __wbg_set_wasm(val) {
    wasm = val;
}

function addToExternrefTable0(obj) {
    const idx = wasm.__externref_table_alloc();
    wasm.__wbindgen_externrefs.set(idx, obj);
    return idx;
}

function _assertBigInt(n) {
    if (typeof(n) !== 'bigint') throw new Error(`expected a bigint argument, found ${typeof(n)}`);
}

function _assertBoolean(n) {
    if (typeof(n) !== 'boolean') {
        throw new Error(`expected a boolean argument, found ${typeof(n)}`);
    }
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
}

function _assertNum(n) {
    if (typeof(n) !== 'number') throw new Error(`expected a number argument, found ${typeof(n)}`);
}

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches && builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

function getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = getDataViewMemory0();
    const result = [];
    for (let i = ptr; i < ptr + 4 * len; i += 4) {
        result.push(wasm.__wbindgen_externrefs.get(mem.getUint32(i, true)));
    }
    wasm.__externref_drop_slice(ptr, len);
    return result;
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

let cachedDataViewMemory0 = null;
function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return decodeText(ptr, len);
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = addToExternrefTable0(e);
        wasm.__wbindgen_exn_store(idx);
    }
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

function logError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        let error = (function () {
            try {
                return e instanceof Error ? `${e.message}\n\nStack:\n${e.stack}` : e.toString();
            } catch(_) {
                return "<failed to stringify thrown value>";
            }
        }());
        console.error("wasm-bindgen: imported JS function that was not marked as `catch` threw an error:", error);
        throw e;
    }
}

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    getUint8ArrayMemory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passArrayJsValueToWasm0(array, malloc) {
    const ptr = malloc(array.length * 4, 4) >>> 0;
    for (let i = 0; i < array.length; i++) {
        const add = addToExternrefTable0(array[i]);
        getDataViewMemory0().setUint32(ptr + 4 * i, add, true);
    }
    WASM_VECTOR_LEN = array.length;
    return ptr;
}

function passStringToWasm0(arg, malloc, realloc) {
    if (typeof(arg) !== 'string') throw new Error(`expected a string argument, found ${typeof(arg)}`);
    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = cachedTextEncoder.encodeInto(arg, view);
        if (ret.read !== arg.length) throw new Error('failed to pass whole string');
        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

function takeFromExternrefTable0(idx) {
    const value = wasm.__wbindgen_externrefs.get(idx);
    wasm.__externref_table_dealloc(idx);
    return value;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

const cachedTextEncoder = new TextEncoder();

if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    }
}

let WASM_VECTOR_LEN = 0;

const DblModelFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_dblmodel_free(ptr >>> 0, 1));

const DblModelDiagramFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_dblmodeldiagram_free(ptr >>> 0, 1));

const DblModelMapFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_dblmodelmap_free(ptr >>> 0, 1));

const DblTheoryFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_dbltheory_free(ptr >>> 0, 1));

const MorTypeIndexFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_mortypeindex_free(ptr >>> 0, 1));

const ObTypeIndexFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_obtypeindex_free(ptr >>> 0, 1));

const ThCategoryFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_thcategory_free(ptr >>> 0, 1));

const ThCategoryLinksFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_thcategorylinks_free(ptr >>> 0, 1));

const ThCategorySignedLinksFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_thcategorysignedlinks_free(ptr >>> 0, 1));

const ThCategoryWithScalarsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_thcategorywithscalars_free(ptr >>> 0, 1));

const ThDelayableSignedCategoryFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_thdelayablesignedcategory_free(ptr >>> 0, 1));

const ThEmptyFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_thempty_free(ptr >>> 0, 1));

const ThNullableSignedCategoryFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_thnullablesignedcategory_free(ptr >>> 0, 1));

const ThPolynomialODEFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_thpolynomialode_free(ptr >>> 0, 1));

const ThPowerSystemFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_thpowersystem_free(ptr >>> 0, 1));

const ThSchemaFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_thschema_free(ptr >>> 0, 1));

const ThSignedCategoryFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_thsignedcategory_free(ptr >>> 0, 1));

const ThSignedPolynomialODEFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_thsignedpolynomialode_free(ptr >>> 0, 1));

const ThSymMonoidalCategoryFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_thsymmonoidalcategory_free(ptr >>> 0, 1));

/**
 * Wasm binding of a model of a double theory.
 */
export class DblModel {
    constructor() {
        throw new Error('cannot invoke `new` directly');
    }
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(DblModel.prototype);
        obj.__wbg_ptr = ptr;
        DblModelFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DblModelFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_dblmodel_free(ptr, 0);
    }
    /**
     * Constructs a serializable presentation of the model.
     * @returns {ModelPresentation}
     */
    presentation() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodel_presentation(this.__wbg_ptr);
        return ret;
    }
    /**
     * Returns the object generators for the model.
     * @returns {QualifiedName[]}
     */
    obGenerators() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodel_obGenerators(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Returns the morphism generators for the model.
     * @returns {QualifiedName[]}
     */
    morGenerators() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodel_morGenerators(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Gets an object generator as it appears in the model's presentation.
     * @param {QualifiedName} id
     * @returns {ObGenerator}
     */
    obPresentation(id) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodel_obPresentation(this.__wbg_ptr, id);
        return ret;
    }
    /**
     * Gets a morphism generator as it appears in the model's presentation.
     * @param {QualifiedName} id
     * @returns {MorGenerator | undefined}
     */
    morPresentation(id) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodel_morPresentation(this.__wbg_ptr, id);
        return ret;
    }
    /**
     * Gets the human-readable label, if any, for an object generator.
     * @param {QualifiedName} id
     * @returns {QualifiedLabel | undefined}
     */
    obGeneratorLabel(id) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodel_obGeneratorLabel(this.__wbg_ptr, id);
        return ret;
    }
    /**
     * Extracts a composition pattern (UWD) from the model.
     * @returns {UWD | undefined}
     */
    compositionPattern() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodel_compositionPattern(this.__wbg_ptr);
        return ret;
    }
    /**
     * Gets the human-readable label, if any, for a morphism generator.
     * @param {QualifiedName} id
     * @returns {QualifiedLabel | undefined}
     */
    morGeneratorLabel(id) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodel_morGeneratorLabel(this.__wbg_ptr, id);
        return ret;
    }
    /**
     * Gets an object generator with the given human-readable label.
     * @param {QualifiedLabel} label
     * @returns {NameLookup}
     */
    obGeneratorWithLabel(label) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodel_obGeneratorWithLabel(this.__wbg_ptr, label);
        return ret;
    }
    /**
     * Returns the object generators of the given object type.
     * @param {ObType} ob_type
     * @returns {QualifiedName[]}
     */
    obGeneratorsWithType(ob_type) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodel_obGeneratorsWithType(this.__wbg_ptr, ob_type);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Gets a morphism generator with the given human-readable label.
     * @param {QualifiedLabel} label
     * @returns {NameLookup}
     */
    morGeneratorWithLabel(label) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodel_morGeneratorWithLabel(this.__wbg_ptr, label);
        return ret;
    }
    /**
     * Returns the morphism generators of the given morphism type.
     * @param {MorType} mor_type
     * @returns {QualifiedName[]}
     */
    morGeneratorsWithType(mor_type) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodel_morGeneratorsWithType(this.__wbg_ptr, mor_type);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Gets the codomain of a morphism in the model.
     * @param {Mor} mor
     * @returns {Ob}
     */
    cod(mor) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodel_cod(this.__wbg_ptr, mor);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Gets the domain of a morphism in the model.
     * @param {Mor} mor
     * @returns {Ob}
     */
    dom(mor) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodel_dom(this.__wbg_ptr, mor);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Is the object contained in the model?
     * @param {Ob} ob
     * @returns {boolean}
     */
    hasOb(ob) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodel_hasOb(this.__wbg_ptr, ob);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * Is the morphism contained in the model?
     * @param {Mor} mor
     * @returns {boolean}
     */
    hasMor(mor) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodel_hasMor(this.__wbg_ptr, mor);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * Gets the object type of an object in the model.
     * @param {Ob} ob
     * @returns {ObType}
     */
    obType(ob) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodel_obType(this.__wbg_ptr, ob);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Gets the morphism type of a morphism in the model.
     * @param {Mor} mor
     * @returns {MorType}
     */
    morType(mor) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodel_morType(this.__wbg_ptr, mor);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Validates the model, returning any validation failures.
     * @returns {ModelValidationResult}
     */
    validate() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodel_validate(this.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) DblModel.prototype[Symbol.dispose] = DblModel.prototype.free;

/**
 * Wasm binding for a diagram in a model of a double theory.
 */
export class DblModelDiagram {
    constructor() {
        throw new Error('cannot invoke `new` directly');
    }
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(DblModelDiagram.prototype);
        obj.__wbg_ptr = ptr;
        DblModelDiagramFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DblModelDiagramFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_dblmodeldiagram_free(ptr, 0);
    }
    /**
     * Validates that the diagram is well defined in a model.
     * @param {DblModel} model
     * @returns {ModelDiagramValidationResult}
     */
    validateIn(model) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.dblmodeldiagram_validateIn(this.__wbg_ptr, model.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Constructs a serializable presentation of the diagram.
     * @returns {ModelDiagramPresentation}
     */
    presentation() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodeldiagram_presentation(this.__wbg_ptr);
        return ret;
    }
    /**
     * Returns the object generators for the diagram's indexing model.
     * @returns {QualifiedName[]}
     */
    obGenerators() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodeldiagram_obGenerators(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Returns the morphism generators for the diagram's indexing model.
     * @returns {QualifiedName[]}
     */
    morGenerators() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodeldiagram_morGenerators(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Gets an object generator as it appears in the diagram's presentation.
     * @param {QualifiedName} id
     * @returns {DiagramObGenerator | undefined}
     */
    obPresentation(id) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodeldiagram_obPresentation(this.__wbg_ptr, id);
        return ret;
    }
    /**
     * Gets a morphism generator as it appears in the diagram's presentation.
     * @param {QualifiedName} id
     * @returns {DiagramMorGenerator | undefined}
     */
    morPresentation(id) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodeldiagram_morPresentation(this.__wbg_ptr, id);
        return ret;
    }
    /**
     * Infers missing data in the diagram from the model, where possible.
     * @param {DblModel} model
     */
    inferMissingFrom(model) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.dblmodeldiagram_inferMissingFrom(this.__wbg_ptr, model.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * Gets the label, if any, for an object generator in the indexing model.
     * @param {QualifiedName} id
     * @returns {QualifiedLabel | undefined}
     */
    obGeneratorLabel(id) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodeldiagram_obGeneratorLabel(this.__wbg_ptr, id);
        return ret;
    }
    /**
     * Gets an object generator with the given label in the indexing model.
     * @param {QualifiedLabel} label
     * @returns {NameLookup}
     */
    obGeneratorWithLabel(label) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodeldiagram_obGeneratorWithLabel(this.__wbg_ptr, label);
        return ret;
    }
    /**
     * Returns the object generators of the given object type.
     * @param {ObType} ob_type
     * @returns {QualifiedName[]}
     */
    obGeneratorsWithType(ob_type) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodeldiagram_obGeneratorsWithType(this.__wbg_ptr, ob_type);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Returns the morphism generators of the given morphism type.
     * @param {MorType} mor_type
     * @returns {QualifiedName[]}
     */
    morGeneratorsWithType(mor_type) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodeldiagram_morGeneratorsWithType(this.__wbg_ptr, mor_type);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Gets the object type of an object in the diagram's indexing model.
     * @param {Ob} ob
     * @returns {ObType}
     */
    obType(ob) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodeldiagram_obType(this.__wbg_ptr, ob);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Gets the morphism type of a morphism in the diagram's indexing model.
     * @param {Mor} mor
     * @returns {MorType}
     */
    morType(mor) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dblmodeldiagram_morType(this.__wbg_ptr, mor);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
}
if (Symbol.dispose) DblModelDiagram.prototype[Symbol.dispose] = DblModelDiagram.prototype.free;

/**
 * A named collection of models of double theories.
 */
export class DblModelMap {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DblModelMapFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_dblmodelmap_free(ptr, 0);
    }
    /**
     * Returns whether the collection contains a model with the given name.
     * @param {string} id
     * @returns {boolean}
     */
    has(id) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.dblmodelmap_has(this.__wbg_ptr, ptr0, len0);
        return ret !== 0;
    }
    /**
     * Constructs an empty collection of models.
     */
    constructor() {
        const ret = wasm.dblmodelmap_new();
        this.__wbg_ptr = ret >>> 0;
        DblModelMapFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Inserts a model with the given name.
     * @param {string} id
     * @param {DblModel} model
     */
    set(id, model) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        wasm.dblmodelmap_set(this.__wbg_ptr, ptr0, len0, model.__wbg_ptr);
    }
}
if (Symbol.dispose) DblModelMap.prototype[Symbol.dispose] = DblModelMap.prototype.free;

/**
 * Wasm binding for a double theory.
 */
export class DblTheory {
    constructor() {
        throw new Error('cannot invoke `new` directly');
    }
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(DblTheory.prototype);
        obj.__wbg_ptr = ptr;
        DblTheoryFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        DblTheoryFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_dbltheory_free(ptr, 0);
    }
    /**
     * Returns whether the theory contains the object type.
     * @param {ObType} ob_type
     * @returns {boolean}
     */
    hasObType(ob_type) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dbltheory_hasObType(this.__wbg_ptr, ob_type);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * Returns whether the theory contains the morphism type.
     * @param {MorType} mor_type
     * @returns {boolean}
     */
    hasMorType(mor_type) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dbltheory_hasMorType(this.__wbg_ptr, mor_type);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * Gets the codomain of an object operation.
     * @param {ObOp} op
     * @returns {ObType}
     */
    cod(op) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dbltheory_cod(this.__wbg_ptr, op);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Gets the domain of an object operation.
     * @param {ObOp} op
     * @returns {ObType}
     */
    dom(op) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dbltheory_dom(this.__wbg_ptr, op);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Gets the source of a morphism type.
     * @param {MorType} mor_type
     * @returns {ObType}
     */
    src(mor_type) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dbltheory_src(this.__wbg_ptr, mor_type);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Gets the target of a morphism type.
     * @param {MorType} mor_type
     * @returns {ObType}
     */
    tgt(mor_type) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.dbltheory_tgt(this.__wbg_ptr, mor_type);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
}
if (Symbol.dispose) DblTheory.prototype[Symbol.dispose] = DblTheory.prototype.free;

/**
 * Mapping from morphism types to numerical indices.
 *
 * Like [`ObTypeIndex`], this struct just compensates for the lack of hash maps
 * with arbitrary keys in JavaScript.
 */
export class MorTypeIndex {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MorTypeIndexFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_mortypeindex_free(ptr, 0);
    }
    /**
     * Returns whether the morphism type is set.
     * @param {MorType} m
     * @returns {boolean}
     */
    has(m) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.mortypeindex_has(this.__wbg_ptr, m);
        return ret !== 0;
    }
    /**
     * Gets the index of a morphism type, if set.
     * @param {MorType} m
     * @returns {number | undefined}
     */
    get(m) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.mortypeindex_get(this.__wbg_ptr, m);
        return ret === 0x100000001 ? undefined : ret;
    }
    /**
     * Creates a new morphism type index.
     */
    constructor() {
        const ret = wasm.mortypeindex_new();
        this.__wbg_ptr = ret >>> 0;
        MorTypeIndexFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Sets the index of a morphism type.
     * @param {MorType} m
     * @param {number} i
     */
    set(m, i) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertNum(i);
        wasm.mortypeindex_set(this.__wbg_ptr, m, i);
    }
}
if (Symbol.dispose) MorTypeIndex.prototype[Symbol.dispose] = MorTypeIndex.prototype.free;

/**
 * Mapping from object types to numerical indices.
 *
 * Like [`MorTypeIndex`], this struct just compensates for the lack of hash maps
 * with arbitrary keys in JavaScript.
 */
export class ObTypeIndex {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ObTypeIndexFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_obtypeindex_free(ptr, 0);
    }
    /**
     * Returns whether the object type is set.
     * @param {ObType} x
     * @returns {boolean}
     */
    has(x) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.obtypeindex_has(this.__wbg_ptr, x);
        return ret !== 0;
    }
    /**
     * Gets the index of an object type, if set.
     * @param {ObType} x
     * @returns {number | undefined}
     */
    get(x) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.obtypeindex_get(this.__wbg_ptr, x);
        return ret === 0x100000001 ? undefined : ret;
    }
    /**
     * Creates a new object type index.
     */
    constructor() {
        const ret = wasm.obtypeindex_new();
        this.__wbg_ptr = ret >>> 0;
        ObTypeIndexFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Sets the index of an object type.
     * @param {ObType} x
     * @param {number} i
     */
    set(x, i) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertNum(i);
        wasm.obtypeindex_set(this.__wbg_ptr, x, i);
    }
}
if (Symbol.dispose) ObTypeIndex.prototype[Symbol.dispose] = ObTypeIndex.prototype.free;

/**
 * The theory of categories.
 */
export class ThCategory {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ThCategoryFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_thcategory_free(ptr, 0);
    }
    constructor() {
        const ret = wasm.thcategory_new();
        this.__wbg_ptr = ret >>> 0;
        ThCategoryFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {DblTheory}
     */
    theory() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.thcategory_theory(this.__wbg_ptr);
        return DblTheory.__wrap(ret);
    }
    /**
     * Sigma migrates a category to a schema.
     * @param {DblModel} boxed
     * @param {DblTheory} th_schema
     * @returns {DblModel}
     */
    static toSchema(boxed, th_schema) {
        _assertClass(boxed, DblModel);
        if (boxed.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        _assertClass(th_schema, DblTheory);
        if (th_schema.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thcategory_toSchema(boxed.__wbg_ptr, th_schema.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return DblModel.__wrap(ret[0]);
    }
}
if (Symbol.dispose) ThCategory.prototype[Symbol.dispose] = ThCategory.prototype.free;

/**
 * The theory of categories with links.
 */
export class ThCategoryLinks {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ThCategoryLinksFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_thcategorylinks_free(ptr, 0);
    }
    /**
     * Simulates the mass-action ODE system derived from a model.
     * @param {DblModel} model
     * @param {MassActionProblemData} data
     * @returns {ODEResultWithEquations}
     */
    massAction(model, data) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thcategorylinks_massAction(this.__wbg_ptr, model.__wbg_ptr, data);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Returns the symbolic mass-action equations in LaTeX format.
     * @param {DblModel} model
     * @param {MassActionEquationsData} data
     * @returns {LatexEquations}
     */
    massActionEquations(model, data) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thcategorylinks_massActionEquations(this.__wbg_ptr, model.__wbg_ptr, data);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    constructor() {
        const ret = wasm.thcategorylinks_new();
        this.__wbg_ptr = ret >>> 0;
        ThCategoryLinksFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {DblTheory}
     */
    theory() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.thcategorylinks_theory(this.__wbg_ptr);
        return DblTheory.__wrap(ret);
    }
}
if (Symbol.dispose) ThCategoryLinks.prototype[Symbol.dispose] = ThCategoryLinks.prototype.free;

/**
 * The theory of categories with signed links.
 */
export class ThCategorySignedLinks {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ThCategorySignedLinksFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_thcategorysignedlinks_free(ptr, 0);
    }
    /**
     * Simulates the mass-action ODE system derived from a model.
     * @param {DblModel} model
     * @param {MassActionProblemData} data
     * @returns {ODEResultWithEquations}
     */
    massAction(model, data) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thcategorysignedlinks_massAction(this.__wbg_ptr, model.__wbg_ptr, data);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Returns the symbolic mass-action equations in LaTeX format.
     * @param {DblModel} model
     * @param {MassActionEquationsData} data
     * @returns {LatexEquations}
     */
    massActionEquations(model, data) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thcategorysignedlinks_massActionEquations(this.__wbg_ptr, model.__wbg_ptr, data);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    constructor() {
        const ret = wasm.thcategorysignedlinks_new();
        this.__wbg_ptr = ret >>> 0;
        ThCategorySignedLinksFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {DblTheory}
     */
    theory() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.thcategorysignedlinks_theory(this.__wbg_ptr);
        return DblTheory.__wrap(ret);
    }
}
if (Symbol.dispose) ThCategorySignedLinks.prototype[Symbol.dispose] = ThCategorySignedLinks.prototype.free;

/**
 * The theory of categories with scalars.
 */
export class ThCategoryWithScalars {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ThCategoryWithScalarsFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_thcategorywithscalars_free(ptr, 0);
    }
    constructor() {
        const ret = wasm.thcategorywithscalars_new();
        this.__wbg_ptr = ret >>> 0;
        ThCategoryWithScalarsFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {DblTheory}
     */
    theory() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.thcategorywithscalars_theory(this.__wbg_ptr);
        return DblTheory.__wrap(ret);
    }
}
if (Symbol.dispose) ThCategoryWithScalars.prototype[Symbol.dispose] = ThCategoryWithScalars.prototype.free;

/**
 * The theory of delayable signed categories.
 */
export class ThDelayableSignedCategory {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ThDelayableSignedCategoryFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_thdelayablesignedcategory_free(ptr, 0);
    }
    /**
     * Find (fast) negative feedback loops in a model.
     * @param {DblModel} model
     * @param {MotifsOptions} options
     * @returns {MotifOccurrence[]}
     */
    negativeLoops(model, options) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thdelayablesignedcategory_negativeLoops(this.__wbg_ptr, model.__wbg_ptr, options);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Find (fast) positive feedback loops in a model.
     * @param {DblModel} model
     * @param {MotifsOptions} options
     * @returns {MotifOccurrence[]}
     */
    positiveLoops(model, options) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thdelayablesignedcategory_positiveLoops(this.__wbg_ptr, model.__wbg_ptr, options);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Sigma migrates a delayable signed category to a signed category.
     * @param {DblModel} boxed
     * @param {DblTheory} th
     * @returns {DblModel}
     */
    static toSignedCategory(boxed, th) {
        _assertClass(boxed, DblModel);
        if (boxed.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        _assertClass(th, DblTheory);
        if (th.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thdelayablesignedcategory_toSignedCategory(boxed.__wbg_ptr, th.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return DblModel.__wrap(ret[0]);
    }
    /**
     * Find delayed negative feedback loops in a model.
     * @param {DblModel} model
     * @param {MotifsOptions} options
     * @returns {MotifOccurrence[]}
     */
    delayedNegativeLoops(model, options) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thdelayablesignedcategory_delayedNegativeLoops(this.__wbg_ptr, model.__wbg_ptr, options);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Find delayed positive feedback loops in a model.
     * @param {DblModel} model
     * @param {MotifsOptions} options
     * @returns {MotifOccurrence[]}
     */
    delayedPositiveLoops(model, options) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thdelayablesignedcategory_delayedPositiveLoops(this.__wbg_ptr, model.__wbg_ptr, options);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    constructor() {
        const ret = wasm.thdelayablesignedcategory_new();
        this.__wbg_ptr = ret >>> 0;
        ThDelayableSignedCategoryFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {DblTheory}
     */
    theory() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.thdelayablesignedcategory_theory(this.__wbg_ptr);
        return DblTheory.__wrap(ret);
    }
}
if (Symbol.dispose) ThDelayableSignedCategory.prototype[Symbol.dispose] = ThDelayableSignedCategory.prototype.free;

/**
 * The empty or initial theory.
 */
export class ThEmpty {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ThEmptyFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_thempty_free(ptr, 0);
    }
    constructor() {
        const ret = wasm.thempty_new();
        this.__wbg_ptr = ret >>> 0;
        ThEmptyFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {DblTheory}
     */
    theory() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.thempty_theory(this.__wbg_ptr);
        return DblTheory.__wrap(ret);
    }
}
if (Symbol.dispose) ThEmpty.prototype[Symbol.dispose] = ThEmpty.prototype.free;

/**
 * The theory of nullable signed categories.
 */
export class ThNullableSignedCategory {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ThNullableSignedCategoryFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_thnullablesignedcategory_free(ptr, 0);
    }
    /**
     * @param {DblModel} model
     * @param {MotifsOptions} options
     * @returns {MotifOccurrence[]}
     */
    negativeLoops(model, options) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thnullablesignedcategory_negativeLoops(this.__wbg_ptr, model.__wbg_ptr, options);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @param {DblModel} model
     * @param {MotifsOptions} options
     * @returns {MotifOccurrence[]}
     */
    positiveLoops(model, options) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thnullablesignedcategory_positiveLoops(this.__wbg_ptr, model.__wbg_ptr, options);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @param {DblModel} model
     * @param {MotifsOptions} options
     * @returns {MotifOccurrence[]}
     */
    indeterminateLoops(model, options) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thnullablesignedcategory_indeterminateLoops(this.__wbg_ptr, model.__wbg_ptr, options);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    constructor() {
        const ret = wasm.thnullablesignedcategory_new();
        this.__wbg_ptr = ret >>> 0;
        ThNullableSignedCategoryFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {DblTheory}
     */
    theory() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.thnullablesignedcategory_theory(this.__wbg_ptr);
        return DblTheory.__wrap(ret);
    }
}
if (Symbol.dispose) ThNullableSignedCategory.prototype[Symbol.dispose] = ThNullableSignedCategory.prototype.free;

/**
 * A theory of systems of polynomial ODEs
 */
export class ThPolynomialODE {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ThPolynomialODEFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_thpolynomialode_free(ptr, 0);
    }
    /**
     * Returns the symbolic equations in LaTeX format.
     * @param {DblModel} model
     * @param {PolynomialODEEquationsData} data
     * @returns {LatexEquations}
     */
    polynomialODEEquations(model, data) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thpolynomialode_polynomialODEEquations(this.__wbg_ptr, model.__wbg_ptr, data);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Simulates the ODE system derived from a model.
     * @param {DblModel} model
     * @param {PolynomialODEProblemData} data
     * @returns {ODEResultWithEquations}
     */
    polynomialODESimulation(model, data) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thpolynomialode_polynomialODESimulation(this.__wbg_ptr, model.__wbg_ptr, data);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    constructor() {
        const ret = wasm.thpolynomialode_new();
        this.__wbg_ptr = ret >>> 0;
        ThPolynomialODEFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {DblTheory}
     */
    theory() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.thpolynomialode_theory(this.__wbg_ptr);
        return DblTheory.__wrap(ret);
    }
}
if (Symbol.dispose) ThPolynomialODE.prototype[Symbol.dispose] = ThPolynomialODE.prototype.free;

/**
 * A theory of power systems.
 */
export class ThPowerSystem {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ThPowerSystemFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_thpowersystem_free(ptr, 0);
    }
    constructor() {
        const ret = wasm.thpowersystem_new();
        this.__wbg_ptr = ret >>> 0;
        ThPowerSystemFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {DblTheory}
     */
    theory() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.thpowersystem_theory(this.__wbg_ptr);
        return DblTheory.__wrap(ret);
    }
    /**
     * Simulates the Kuramoto system derived from a model.
     * @param {DblModel} model
     * @param {KuramotoProblemData} data
     * @returns {ODEResult}
     */
    kuramoto(model, data) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thpowersystem_kuramoto(this.__wbg_ptr, model.__wbg_ptr, data);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
}
if (Symbol.dispose) ThPowerSystem.prototype[Symbol.dispose] = ThPowerSystem.prototype.free;

/**
 * The theory of database schemas with attributes.
 */
export class ThSchema {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ThSchemaFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_thschema_free(ptr, 0);
    }
    /**
     * Renders a model into valid SQL
     * @param {DblModel} model
     * @param {string} backend
     * @returns {JsResult}
     */
    renderSQL(model, backend) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ptr0 = passStringToWasm0(backend, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.thschema_renderSQL(this.__wbg_ptr, model.__wbg_ptr, ptr0, len0);
        return ret;
    }
    /**
     * Sigma migrates a schema to a category.
     * @param {DblModel} boxed
     * @param {DblTheory} th_category
     * @returns {DblModel}
     */
    static toCategory(boxed, th_category) {
        _assertClass(boxed, DblModel);
        if (boxed.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        _assertClass(th_category, DblTheory);
        if (th_category.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thschema_toCategory(boxed.__wbg_ptr, th_category.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return DblModel.__wrap(ret[0]);
    }
    constructor() {
        const ret = wasm.thschema_new();
        this.__wbg_ptr = ret >>> 0;
        ThSchemaFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {DblTheory}
     */
    theory() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.thschema_theory(this.__wbg_ptr);
        return DblTheory.__wrap(ret);
    }
}
if (Symbol.dispose) ThSchema.prototype[Symbol.dispose] = ThSchema.prototype.free;

/**
 * The theory of signed categories.
 */
export class ThSignedCategory {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ThSignedCategoryFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_thsignedcategory_free(ptr, 0);
    }
    /**
     * Simulate the linear ODE system derived from a model.
     * @param {DblModel} model
     * @param {LinearODEProblemData} data
     * @returns {ODEResult}
     */
    linearODE(model, data) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thsignedcategory_linearODE(this.__wbg_ptr, model.__wbg_ptr, data);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Simulate the Lotka-Volterra system derived from a model.
     * @param {DblModel} model
     * @param {LotkaVolterraProblemData} data
     * @returns {ODEResult}
     */
    lotkaVolterra(model, data) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thsignedcategory_lotkaVolterra(this.__wbg_ptr, model.__wbg_ptr, data);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Find negative feedback loops in a model.
     * @param {DblModel} model
     * @param {MotifsOptions} options
     * @returns {MotifOccurrence[]}
     */
    negativeLoops(model, options) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thsignedcategory_negativeLoops(this.__wbg_ptr, model.__wbg_ptr, options);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * Find positive feedback loops in a model.
     * @param {DblModel} model
     * @param {MotifsOptions} options
     * @returns {MotifOccurrence[]}
     */
    positiveLoops(model, options) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thsignedcategory_positiveLoops(this.__wbg_ptr, model.__wbg_ptr, options);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    constructor() {
        const ret = wasm.thsignedcategory_new();
        this.__wbg_ptr = ret >>> 0;
        ThSignedCategoryFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {DblTheory}
     */
    theory() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.thsignedcategory_theory(this.__wbg_ptr);
        return DblTheory.__wrap(ret);
    }
}
if (Symbol.dispose) ThSignedCategory.prototype[Symbol.dispose] = ThSignedCategory.prototype.free;

/**
 * A theory of systems of signed polynomial ODEs
 */
export class ThSignedPolynomialODE {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ThSignedPolynomialODEFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_thsignedpolynomialode_free(ptr, 0);
    }
    /**
     * Returns the symbolic equations in LaTeX format.
     * @param {DblModel} model
     * @param {PolynomialODEEquationsData} data
     * @returns {LatexEquations}
     */
    polynomialODEEquations(model, data) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thsignedpolynomialode_polynomialODEEquations(this.__wbg_ptr, model.__wbg_ptr, data);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Simulates the ODE system derived from a model.
     * @param {DblModel} model
     * @param {PolynomialODEProblemData} data
     * @returns {ODEResultWithEquations}
     */
    polynomialODESimulation(model, data) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thsignedpolynomialode_polynomialODESimulation(this.__wbg_ptr, model.__wbg_ptr, data);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    constructor() {
        const ret = wasm.thsignedpolynomialode_new();
        this.__wbg_ptr = ret >>> 0;
        ThSignedPolynomialODEFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {DblTheory}
     */
    theory() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.thsignedpolynomialode_theory(this.__wbg_ptr);
        return DblTheory.__wrap(ret);
    }
}
if (Symbol.dispose) ThSignedPolynomialODE.prototype[Symbol.dispose] = ThSignedPolynomialODE.prototype.free;

/**
 * The theory of strict symmetric monoidal categories.
 */
export class ThSymMonoidalCategory {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ThSymMonoidalCategoryFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_thsymmonoidalcategory_free(ptr, 0);
    }
    /**
     * Simulates the mass-action ODE system derived from a model.
     * @param {DblModel} model
     * @param {MassActionProblemData} data
     * @returns {ODEResultWithEquations}
     */
    massAction(model, data) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thsymmonoidalcategory_massAction(this.__wbg_ptr, model.__wbg_ptr, data);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Solve the subreachability problem for petri nets.
     * @param {DblModel} model
     * @param {ReachabilityProblemData} data
     * @returns {boolean}
     */
    subreachability(model, data) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thsymmonoidalcategory_subreachability(this.__wbg_ptr, model.__wbg_ptr, data);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return ret[0] !== 0;
    }
    /**
     * Returns the symbolic mass-action equations in LaTeX format.
     * @param {DblModel} model
     * @param {MassActionEquationsData} data
     * @returns {LatexEquations}
     */
    massActionEquations(model, data) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thsymmonoidalcategory_massActionEquations(this.__wbg_ptr, model.__wbg_ptr, data);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Simulates the stochastic mass-action system derived from a model.
     * @param {DblModel} model
     * @param {StochasticMassActionProblemData} data
     * @returns {ODEResult}
     */
    stochasticMassAction(model, data) {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        _assertClass(model, DblModel);
        if (model.__wbg_ptr === 0) {
            throw new Error('Attempt to use a moved value');
        }
        const ret = wasm.thsymmonoidalcategory_stochasticMassAction(this.__wbg_ptr, model.__wbg_ptr, data);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    constructor() {
        const ret = wasm.thsymmonoidalcategory_new();
        this.__wbg_ptr = ret >>> 0;
        ThSymMonoidalCategoryFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {DblTheory}
     */
    theory() {
        if (this.__wbg_ptr == 0) throw new Error('Attempt to use a moved value');
        _assertNum(this.__wbg_ptr);
        const ret = wasm.thsymmonoidalcategory_theory(this.__wbg_ptr);
        return DblTheory.__wrap(ret);
    }
}
if (Symbol.dispose) ThSymMonoidalCategory.prototype[Symbol.dispose] = ThSymMonoidalCategory.prototype.free;

/**
 * Collects application of a product operation into a list of objects.
 * @param {Ob} ob
 * @returns {Ob[]}
 */
export function collectProduct(ob) {
    const ret = wasm.collectProduct(ob);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v1;
}

/**
 * @returns {string}
 */
export function currentVersion() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.currentVersion();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * Elaborates a diagram defined by a notebook into a catlog diagram.
 * @param {DiagramJudgment[]} judgments
 * @param {DblTheory} theory
 * @returns {DblModelDiagram}
 */
export function elaborateDiagram(judgments, theory) {
    const ptr0 = passArrayJsValueToWasm0(judgments, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    _assertClass(theory, DblTheory);
    if (theory.__wbg_ptr === 0) {
        throw new Error('Attempt to use a moved value');
    }
    const ret = wasm.elaborateDiagram(ptr0, len0, theory.__wbg_ptr);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return DblModelDiagram.__wrap(ret[0]);
}

/**
 * Elaborates a model defined by a notebook into a catlog model.
 * @param {ModelNotebook} notebook
 * @param {DblModelMap} instantiated
 * @param {DblTheory} theory
 * @param {string} ref_id
 * @returns {DblModel}
 */
export function elaborateModel(notebook, instantiated, theory, ref_id) {
    _assertClass(instantiated, DblModelMap);
    if (instantiated.__wbg_ptr === 0) {
        throw new Error('Attempt to use a moved value');
    }
    _assertClass(theory, DblTheory);
    if (theory.__wbg_ptr === 0) {
        throw new Error('Attempt to use a moved value');
    }
    const ptr0 = passStringToWasm0(ref_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.elaborateModel(notebook, instantiated.__wbg_ptr, theory.__wbg_ptr, ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return DblModel.__wrap(ret[0]);
}

/**
 * @param {any} input
 * @returns {any}
 */
export function migrateDocument(input) {
    const ret = wasm.migrateDocument(input);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Serialize an Automerge document to JSON, encoding rich-text spans.
 * @param {Uint8Array} input
 * @returns {any}
 */
export function serializeAutomergeDocument(input) {
    const ptr0 = passArray8ToWasm0(input, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.serializeAutomergeDocument(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return takeFromExternrefTable0(ret[0]);
}

/**
 * Set panic hook to get better error messages on panics.
 *
 * When the `console_error_panic_hook` feature is enabled, we can call the
 * `set_panic_hook` function at least once during initialization, and then we will
 * get better error messages if our code ever panics.
 *
 * For more details see <https://github.com/rustwasm/console_error_panic_hook#readme>
 */
export function set_panic_hook() {
    wasm.set_panic_hook();
}

export function __wbg_Error_52673b7de5a0ca89() { return logError(function (arg0, arg1) {
    const ret = Error(getStringFromWasm0(arg0, arg1));
    return ret;
}, arguments) };

export function __wbg_Number_2d1dcfcf4ec51736() { return logError(function (arg0) {
    const ret = Number(arg0);
    return ret;
}, arguments) };

export function __wbg_String_8f0eb39a4a4c2f66() { return logError(function (arg0, arg1) {
    const ret = String(arg1);
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}, arguments) };

export function __wbg___wbindgen_bigint_get_as_i64_6e32f5e6aff02e1d(arg0, arg1) {
    const v = arg1;
    const ret = typeof(v) === 'bigint' ? v : undefined;
    if (!isLikeNone(ret)) {
        _assertBigInt(ret);
    }
    getDataViewMemory0().setBigInt64(arg0 + 8 * 1, isLikeNone(ret) ? BigInt(0) : ret, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
};

export function __wbg___wbindgen_boolean_get_dea25b33882b895b(arg0) {
    const v = arg0;
    const ret = typeof(v) === 'boolean' ? v : undefined;
    if (!isLikeNone(ret)) {
        _assertBoolean(ret);
    }
    return isLikeNone(ret) ? 0xFFFFFF : ret ? 1 : 0;
};

export function __wbg___wbindgen_debug_string_adfb662ae34724b6(arg0, arg1) {
    const ret = debugString(arg1);
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbg___wbindgen_in_0d3e1e8f0c669317(arg0, arg1) {
    const ret = arg0 in arg1;
    _assertBoolean(ret);
    return ret;
};

export function __wbg___wbindgen_is_bigint_0e1a2e3f55cfae27(arg0) {
    const ret = typeof(arg0) === 'bigint';
    _assertBoolean(ret);
    return ret;
};

export function __wbg___wbindgen_is_function_8d400b8b1af978cd(arg0) {
    const ret = typeof(arg0) === 'function';
    _assertBoolean(ret);
    return ret;
};

export function __wbg___wbindgen_is_object_ce774f3490692386(arg0) {
    const val = arg0;
    const ret = typeof(val) === 'object' && val !== null;
    _assertBoolean(ret);
    return ret;
};

export function __wbg___wbindgen_is_string_704ef9c8fc131030(arg0) {
    const ret = typeof(arg0) === 'string';
    _assertBoolean(ret);
    return ret;
};

export function __wbg___wbindgen_is_undefined_f6b95eab589e0269(arg0) {
    const ret = arg0 === undefined;
    _assertBoolean(ret);
    return ret;
};

export function __wbg___wbindgen_jsval_eq_b6101cc9cef1fe36(arg0, arg1) {
    const ret = arg0 === arg1;
    _assertBoolean(ret);
    return ret;
};

export function __wbg___wbindgen_jsval_loose_eq_766057600fdd1b0d(arg0, arg1) {
    const ret = arg0 == arg1;
    _assertBoolean(ret);
    return ret;
};

export function __wbg___wbindgen_number_get_9619185a74197f95(arg0, arg1) {
    const obj = arg1;
    const ret = typeof(obj) === 'number' ? obj : undefined;
    if (!isLikeNone(ret)) {
        _assertNum(ret);
    }
    getDataViewMemory0().setFloat64(arg0 + 8 * 1, isLikeNone(ret) ? 0 : ret, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
};

export function __wbg___wbindgen_string_get_a2a31e16edf96e42(arg0, arg1) {
    const obj = arg1;
    const ret = typeof(obj) === 'string' ? obj : undefined;
    var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbg___wbindgen_throw_dd24417ed36fc46e(arg0, arg1) {
    throw new Error(getStringFromWasm0(arg0, arg1));
};

export function __wbg_call_abb4ff46ce38be40() { return handleError(function (arg0, arg1) {
    const ret = arg0.call(arg1);
    return ret;
}, arguments) };

export function __wbg_done_62ea16af4ce34b24() { return logError(function (arg0) {
    const ret = arg0.done;
    _assertBoolean(ret);
    return ret;
}, arguments) };

export function __wbg_entries_83c79938054e065f() { return logError(function (arg0) {
    const ret = Object.entries(arg0);
    return ret;
}, arguments) };

export function __wbg_error_7534b8e9a36f1ab4() { return logError(function (arg0, arg1) {
    let deferred0_0;
    let deferred0_1;
    try {
        deferred0_0 = arg0;
        deferred0_1 = arg1;
        console.error(getStringFromWasm0(arg0, arg1));
    } finally {
        wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
    }
}, arguments) };

export function __wbg_from_29a8414a7a7cd19d() { return logError(function (arg0) {
    const ret = Array.from(arg0);
    return ret;
}, arguments) };

export function __wbg_getRandomValues_3c9c0d586e575a16() { return handleError(function (arg0, arg1) {
    globalThis.crypto.getRandomValues(getArrayU8FromWasm0(arg0, arg1));
}, arguments) };

export function __wbg_get_6b7bd52aca3f9671() { return logError(function (arg0, arg1) {
    const ret = arg0[arg1 >>> 0];
    return ret;
}, arguments) };

export function __wbg_get_af9dab7e9603ea93() { return handleError(function (arg0, arg1) {
    const ret = Reflect.get(arg0, arg1);
    return ret;
}, arguments) };

export function __wbg_get_with_ref_key_1dc361bd10053bfe() { return logError(function (arg0, arg1) {
    const ret = arg0[arg1];
    return ret;
}, arguments) };

export function __wbg_instanceof_ArrayBuffer_f3320d2419cd0355() { return logError(function (arg0) {
    let result;
    try {
        result = arg0 instanceof ArrayBuffer;
    } catch (_) {
        result = false;
    }
    const ret = result;
    _assertBoolean(ret);
    return ret;
}, arguments) };

export function __wbg_instanceof_Map_084be8da74364158() { return logError(function (arg0) {
    let result;
    try {
        result = arg0 instanceof Map;
    } catch (_) {
        result = false;
    }
    const ret = result;
    _assertBoolean(ret);
    return ret;
}, arguments) };

export function __wbg_instanceof_Uint8Array_da54ccc9d3e09434() { return logError(function (arg0) {
    let result;
    try {
        result = arg0 instanceof Uint8Array;
    } catch (_) {
        result = false;
    }
    const ret = result;
    _assertBoolean(ret);
    return ret;
}, arguments) };

export function __wbg_isArray_51fd9e6422c0a395() { return logError(function (arg0) {
    const ret = Array.isArray(arg0);
    _assertBoolean(ret);
    return ret;
}, arguments) };

export function __wbg_isSafeInteger_ae7d3f054d55fa16() { return logError(function (arg0) {
    const ret = Number.isSafeInteger(arg0);
    _assertBoolean(ret);
    return ret;
}, arguments) };

export function __wbg_iterator_27b7c8b35ab3e86b() { return logError(function () {
    const ret = Symbol.iterator;
    return ret;
}, arguments) };

export function __wbg_length_22ac23eaec9d8053() { return logError(function (arg0) {
    const ret = arg0.length;
    _assertNum(ret);
    return ret;
}, arguments) };

export function __wbg_length_d45040a40c570362() { return logError(function (arg0) {
    const ret = arg0.length;
    _assertNum(ret);
    return ret;
}, arguments) };

export function __wbg_new_1ba21ce319a06297() { return logError(function () {
    const ret = new Object();
    return ret;
}, arguments) };

export function __wbg_new_25f239778d6112b9() { return logError(function () {
    const ret = new Array();
    return ret;
}, arguments) };

export function __wbg_new_6421f6084cc5bc5a() { return logError(function (arg0) {
    const ret = new Uint8Array(arg0);
    return ret;
}, arguments) };

export function __wbg_new_8a6f238a6ece86ea() { return logError(function () {
    const ret = new Error();
    return ret;
}, arguments) };

export function __wbg_new_b546ae120718850e() { return logError(function () {
    const ret = new Map();
    return ret;
}, arguments) };

export function __wbg_new_no_args_cb138f77cf6151ee() { return logError(function (arg0, arg1) {
    const ret = new Function(getStringFromWasm0(arg0, arg1));
    return ret;
}, arguments) };

export function __wbg_next_138a17bbf04e926c() { return logError(function (arg0) {
    const ret = arg0.next;
    return ret;
}, arguments) };

export function __wbg_next_3cfe5c0fe2a4cc53() { return handleError(function (arg0) {
    const ret = arg0.next();
    return ret;
}, arguments) };

export function __wbg_now_2c95c9de01293173() { return logError(function (arg0) {
    const ret = arg0.now();
    return ret;
}, arguments) };

export function __wbg_performance_7a3ffd0b17f663ad() { return logError(function (arg0) {
    const ret = arg0.performance;
    return ret;
}, arguments) };

export function __wbg_prototypesetcall_dfe9b766cdc1f1fd() { return logError(function (arg0, arg1, arg2) {
    Uint8Array.prototype.set.call(getArrayU8FromWasm0(arg0, arg1), arg2);
}, arguments) };

export function __wbg_set_3f1d0b984ed272ed() { return logError(function (arg0, arg1, arg2) {
    arg0[arg1] = arg2;
}, arguments) };

export function __wbg_set_7df433eea03a5c14() { return logError(function (arg0, arg1, arg2) {
    arg0[arg1 >>> 0] = arg2;
}, arguments) };

export function __wbg_set_efaaf145b9377369() { return logError(function (arg0, arg1, arg2) {
    const ret = arg0.set(arg1, arg2);
    return ret;
}, arguments) };

export function __wbg_stack_0ed75d68575b0f3c() { return logError(function (arg0, arg1) {
    const ret = arg1.stack;
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}, arguments) };

export function __wbg_static_accessor_GLOBAL_769e6b65d6557335() { return logError(function () {
    const ret = typeof global === 'undefined' ? null : global;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
}, arguments) };

export function __wbg_static_accessor_GLOBAL_THIS_60cf02db4de8e1c1() { return logError(function () {
    const ret = typeof globalThis === 'undefined' ? null : globalThis;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
}, arguments) };

export function __wbg_static_accessor_SELF_08f5a74c69739274() { return logError(function () {
    const ret = typeof self === 'undefined' ? null : self;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
}, arguments) };

export function __wbg_static_accessor_WINDOW_a8924b26aa92d024() { return logError(function () {
    const ret = typeof window === 'undefined' ? null : window;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
}, arguments) };

export function __wbg_value_57b7b035e117f7ee() { return logError(function (arg0) {
    const ret = arg0.value;
    return ret;
}, arguments) };

export function __wbindgen_cast_2241b6af4c4b2941() { return logError(function (arg0, arg1) {
    // Cast intrinsic for `Ref(String) -> Externref`.
    const ret = getStringFromWasm0(arg0, arg1);
    return ret;
}, arguments) };

export function __wbindgen_cast_4625c577ab2ec9ee() { return logError(function (arg0) {
    // Cast intrinsic for `U64 -> Externref`.
    const ret = BigInt.asUintN(64, arg0);
    return ret;
}, arguments) };

export function __wbindgen_cast_9ae0607507abb057() { return logError(function (arg0) {
    // Cast intrinsic for `I64 -> Externref`.
    const ret = arg0;
    return ret;
}, arguments) };

export function __wbindgen_cast_cb9088102bce6b30() { return logError(function (arg0, arg1) {
    // Cast intrinsic for `Ref(Slice(U8)) -> NamedExternref("Uint8Array")`.
    const ret = getArrayU8FromWasm0(arg0, arg1);
    return ret;
}, arguments) };

export function __wbindgen_cast_d6cd19b81560fd6e() { return logError(function (arg0) {
    // Cast intrinsic for `F64 -> Externref`.
    const ret = arg0;
    return ret;
}, arguments) };

export function __wbindgen_init_externref_table() {
    const table = wasm.__wbindgen_externrefs;
    const offset = table.grow(4);
    table.set(0, undefined);
    table.set(offset + 0, undefined);
    table.set(offset + 1, null);
    table.set(offset + 2, true);
    table.set(offset + 3, false);
};
